## Bearer token

Always send the credential in the `Authorization` header.

Expected format:

`Authorization: Bearer ctt_live_<key_id>.<secret>`

## How authentication works

- Each credential is always tenant-bound.
- The authenticated tenant comes from the credential itself, not from an extra context header.
- The raw secret is shown only during creation and rotation.

## How to get a key

Open [My account > Public API](/account?tab=settings&settings_tab=public_api) and create one credential for the integration.

Creation and rotation show the complete bearer token only once. Store the full value in a secret manager. After that, the product only shows the `key_id` and the last 4 secret characters.

The public API area is shown only for tenants with an active subscription on a plan that enables the public API.

## Scopes

- Every credential carries only the scopes explicitly assigned to it.
- Effective scopes can be inspected through the scopes catalog endpoint.
- If a required scope is missing, the API should respond with an authorization error.
- Implemented scopes: `campaigns.read`, `calls.read`, `calls.write`, `agents.read`, `scripts.read`, `users.read`, and `transfer_groups.read`.

## Allowlist, expiration, and throttling

- When `allowed_ips` is configured, the request is accepted only if the client IP is allowlisted.
- If the credential is expired or revoked, authentication must fail.
- Throttling is enforced per credential, using that key's configured limit.

## Common errors

- `401 Unauthorized`: missing token, invalid token, expired token, revoked credential, or disallowed IP.
- `403 Forbidden`: the credential authenticated successfully, but it does not have the required scope.
- `429 Too Many Requests`: the credential exceeded its allowed limit for the current window.
